/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class TopSniper {
    public static inicializar() {
      let topSniper = new App.TopSniper();
      topSniper.inicializarEventos();
    }
  }
}

namespace App {
  export class TopSniper {
    private idExtensao: string = "pnenhoomfmddepcbmmkpkbdoplmjohge";
    public static readonly USUARIO_TOP_SNIPER_DIEGO = 3;
    public static readonly USUARIO_TOP_SNIPER_FERNANDO = 7;
    public static readonly USUARIO_TOP_SNIPER_MARCELO = 841;
    public static readonly USUARIO_TOP_SNIPER_PC = 28923;

    private userId: number = null;
    private static readonly USUARIOS_PERMITIDOS: any = [TopSniper.USUARIO_TOP_SNIPER_DIEGO, TopSniper.USUARIO_TOP_SNIPER_FERNANDO, TopSniper.USUARIO_TOP_SNIPER_MARCELO, TopSniper.USUARIO_TOP_SNIPER_PC];
    private urlUpdateFiltro: string = null;
    private idPlataforma: any = 1;
    public valorInvestido: number;
    public snipou: number;
    public disputaPerdida: number;
    public valorFutbin: number;
    public keyStorageCachePrecoFutbin: string = "key_storage_cache_preco_futbin";
    private keyStorageForcarPrecoFrescoFernando: string = "topSniperFernandoForcarPrecoFrescoAte";
    private keyStorageInstanciaTokenFernando: string = "topSniperFernandoInstanciaTokenV1";
    public minutosCachePrecoFutbin: number = 60; //1 hora
    public static objDataTableTopSniper: any = null;
    public static objPlayers: IPlayerJson = null;
    private objPlayersPorId: any = {};
    public elDataTableTopSniper: any = $("#dataTableTopSnipers");
    public static objJogadorDefault: any = { "f": "Não", "id": 0, "l": "Identificado", "r": 0 };
    private topSniperAdminFernando: TopSniperFernando = null
    private topSniperAdminDiego: TopSniperDiego = null
    private topSniperPc: TopSniperPc = null
    private topSniperMarcelo: TopSniperMarcelo = null
    private urlsInteligenciaFernando: any = {}
    private cachePrecoFutbinMemoria: IStoragePrecoFutbin[] = null;
    private indiceCachePrecoFutbin: any = null;
    private cachePrecoFutbinAlterado: boolean = false;
    private precosExternosFernandoPendentes: any[] = [];
    private timeoutFlushPrecosExternosFernando: any = null;
    private timeoutLoopTopSniper: any = null;
    private limiteCachePrecoFutbin: number = 500;
    private limiteBuscaPrecoExternoFernando: number = 24;
    private limiteBuscaPrecoExternoFernandoForcado: number = 12;
    private limiteRegistroPrecoExternoFernando: number = 16;
    private limiteRegistroPrecoExternoFernandoForcado: number = 12;
    private processandoPrecosExternosFernando: boolean = false;
    private chavesPrecosExternosFernandoPendentes: any = {};
    // Rede de seguranca: se o ciclo travar antes de agendar o proximo recarregamento
    // (extensao sem responder, erro no meio do pipeline), a tela ficaria parada para sempre.
    private timeoutWatchdogTopSniper: any = null;
    private timeoutRespostaExtensao: number = 15000;
    private timeoutWatchdogRecarregamento: number = 360000; // 6 minutos
    // Disjuntor: com a extensao fora do ar cada carta gastaria o timeout inteiro,
    // fazendo um ciclo de 2 minutos levar horas. Depois de N falhas seguidas o ciclo
    // termina usando so o cache e tenta de novo no proximo carregamento da pagina.
    private falhasConsecutivasExtensao: number = 0;
    private limiteFalhasConsecutivasExtensao: number = 8;
    private extensaoIndisponivel: boolean = false;

    public async inicializarEventos() {
      this.iniciarWatchdogRecarregamento();
      this.userId = $('#section-components').data('idUser')
      this.urlUpdateFiltro = $('#section-components').data('urlUpdateFiltro')
      this.urlsInteligenciaFernando = {
        estado: $('#section-components').data('urlTopSniperInteligenciaEstado'),
        heartbeat: $('#section-components').data('urlTopSniperInteligenciaHeartbeat'),
        decisao: $('#section-components').data('urlTopSniperInteligenciaDecisao'),
        protecao: $('#section-components').data('urlTopSniperInteligenciaProtecao'),
        preco: $('#section-components').data('urlTopSniperInteligenciaPreco'),
        futggSessao: $('#section-components').data('urlTopSniperInteligenciaFutggSessao'),
        controleFiltros: $('#section-components').data('urlTopSniperInteligenciaControleFiltros')
      }
      App.Util.exibirLoadingTableContas()

      var idExtensao: any = await App.Util.aguardarValorElemento('#idExtensao');
      if (idExtensao) {
        this.idExtensao = idExtensao
      }
      let params = new URLSearchParams(window.location.href)
      if (params.get('extension_id')) {
        this.idExtensao = params.get('extension_id')
      }

      if (params.get('id_plataforma')) {
        this.idPlataforma = params.get('id_plataforma')
      }

      $(window).off('beforeunload.topSniper').on('beforeunload.topSniper', (): void => {
        this.limparMemoriaTopSniper();
      });

      this.topSniperAdminFernando = new App.TopSniperFernando(this.urlUpdateFiltro, {
        urls: this.urlsInteligenciaFernando,
        keyStorageCachePrecoFutbin: this.keyStorageCachePrecoFutbin,
        keyStorageForcarPrecoFresco: this.keyStorageForcarPrecoFrescoFernando,
        idExtensao: this.idExtensao,
        idPlataforma: this.idPlataforma
      });
      this.topSniperAdminDiego = new App.TopSniperDiego(this.urlUpdateFiltro);
      this.topSniperPc = new App.TopSniperPc(this.urlUpdateFiltro);
      this.topSniperMarcelo = new App.TopSniperMarcelo(this.urlUpdateFiltro);

      console.log("URL", window.location.href, ` | ID: ${this.userId}`)
      let algumRedirecionamentoNovaUrl = await this.processarRegrasDeUrl(this.userId, window.location.href)
      if (algumRedirecionamentoNovaUrl) {
        console.log("REDIRECIONAMENTO PARA NOVA URL", algumRedirecionamentoNovaUrl)
        window.location.replace(algumRedirecionamentoNovaUrl)
        return
      }

      try {
        await this.inicializarDataTable();
      } catch (erro) {
        console.error('TOP SNIPER: falha no ciclo de carregamento, reagendando', erro);
        App.Util.ocultarLoadingTableContas();
        this.loopBuscasParaAtualizacaoDeFiltros();
      }
    }

    /**
     * Rede de seguranca por FALTA DE PROGRESSO, nao por tempo total do ciclo: cada marco do
     * pipeline rearma o prazo, entao um ciclo lento porem saudavel (Diego/PC/Marcelo chegam a
     * gastar 1s por carta) nunca e abortado antes de salvar os filtros.
     */
    private iniciarWatchdogRecarregamento(prazo: number = null): void {
      this.cancelarWatchdogRecarregamento();

      this.timeoutWatchdogTopSniper = setTimeout((): void => {
        this.timeoutWatchdogTopSniper = null;
        if (this.timeoutLoopTopSniper || !TopSniper.USUARIOS_PERMITIDOS.includes(this.userId)) {
          return;
        }

        console.warn('TOP SNIPER: ciclo sem progresso, recarregando pelo watchdog', new Date().toLocaleTimeString());

        // Sai pela URL limpa, nunca pelo formulario. Quem renova o data_inicio e apenas este
        // caminho; recarregar pelo formulario aqui congelaria a janela do user_sniper, que
        // cresceria a cada watchdog ate estourar a memoria - o problema que estamos corrigindo.
        Util.resetCounter('contadorBuscasTopSniper');
        this.recarregar(this.userId);
      }, prazo ? prazo : this.timeoutWatchdogRecarregamento);
    }

    /**
     * Marca que o ciclo avancou. So rearma se o watchdog ainda estiver ativo (ou seja, enquanto
     * o loop normal de 2 minutos ainda nao assumiu o recarregamento).
     */
    private registrarProgressoCiclo(): void {
      if (!this.timeoutWatchdogTopSniper) {
        return;
      }

      this.iniciarWatchdogRecarregamento();
    }

    private registrarFalhaExtensao(): void {
      this.falhasConsecutivasExtensao++;
      if (this.extensaoIndisponivel || this.falhasConsecutivasExtensao < this.limiteFalhasConsecutivasExtensao) {
        return;
      }

      this.extensaoIndisponivel = true;
      console.warn('TOP SNIPER: extensao sem responder, seguindo o ciclo apenas com cache de preco.');
    }

    private cancelarWatchdogRecarregamento(): void {
      if (this.timeoutWatchdogTopSniper) {
        clearTimeout(this.timeoutWatchdogTopSniper);
        this.timeoutWatchdogTopSniper = null;
      }
    }

    private getPlayers(metodoCallback: any) {
      App.Util.getPlayersJson().then((players: any) => {
        this.objPlayersPorId = this.indexarPlayersPorId(players);
        metodoCallback();
      });
    }

    private async prepararIndicePlayersParaTopSniper(dataTopSnipers: any[]): Promise<void> {
      this.objPlayersPorId = {};
      TopSniper.objPlayers = null;

      let idsNecessarios: any = {};
      (dataTopSnipers || []).forEach((item: any): void => {
        if (item && item.asset_id) {
          idsNecessarios[item.asset_id.toString()] = true;
        }
      });

      try {
        const players = await App.Util.getPlayersJson();
        this.objPlayersPorId = this.indexarPlayersPorId(players, idsNecessarios);
      } catch (e) {
        this.objPlayersPorId = {};
      }
    }

    private indexarPlayersPorId(players: any, idsPermitidos: any = null): any {
      let mapa: any = {};
      if (!$.isArray(players)) {
        return mapa;
      }

      for (let i = 0; i < players.length; i++) {
        let player = players[i];
        if (player && player.id) {
          const id = player.id.toString();
          if (!idsPermitidos || idsPermitidos[id]) {
            mapa[id] = player;
          }
        }
      }

      return mapa;
    }

    private getPlayerPorAssetId(assetId: any): any {
      if (!assetId || !this.objPlayersPorId) {
        return TopSniper.objJogadorDefault;
      }

      let player = this.objPlayersPorId[assetId.toString()];
      return player || TopSniper.objJogadorDefault;
    }

    private async sleep(milisegundos: number) {
      return new Promise((resolve: any) => setTimeout(resolve, milisegundos));
    }

    private normalizarNumero(valor: any): number {
      let numero = Number(valor);
      return isFinite(numero) ? numero : 0;
    }

    private normalizarPrecoFutbin(dados: IFutbin): number {
      if (!dados || !dados.hasOwnProperty('preco')) {
        return 0;
      }

      let preco = Number(dados.preco);
      return isFinite(preco) && preco > 0 ? preco : 0;
    }

    private getNomeJogador(player: any): string {
      if (!player) {
        return 'Nao Identificado';
      }

      if (player.hasOwnProperty('c') && player.c) {
        return player.c;
      }

      let nome = `${player.f || ''} ${player.l || ''}`.trim();
      return nome ? nome : 'Nao Identificado';
    }

    private getPayloadFiltroBuscaPreco(nomeJogador: string, dataSniper: ICartaTopSniper): any {
      return {
        name: nomeJogador,
        termo: nomeJogador,
        rating: dataSniper.rating,
        rareflag: dataSniper.rareflag,
        teamId: dataSniper.team_id,
        assetId: dataSniper.asset_id,
        resourceId: dataSniper.resource_id
      };
    }

    private getChavePrecoTopSniper(resourceId: any, idPlataforma: any): string {
      return `${resourceId || 0}|${idPlataforma || 0}`;
    }

    private getChavesBuscaPrecoExternoFernando(dataTopSnipers: any): any {
      if (this.userId != TopSniper.USUARIO_TOP_SNIPER_FERNANDO) {
        return null;
      }

      let itens = $.isArray(dataTopSnipers) ? dataTopSnipers.slice(0) : [];
      let limite = this.deveForcarPrecoFrescoFernando() ? this.limiteBuscaPrecoExternoFernandoForcado : this.limiteBuscaPrecoExternoFernando;
      let mapa: any = {};
      let totalPermitido = 0;

      itens.sort((a: any, b: any): number => {
        let quantidadeA = this.normalizarNumero(a.quantidade_mais);
        let quantidadeB = this.normalizarNumero(b.quantidade_mais);
        if (quantidadeA != quantidadeB) {
          return quantidadeB - quantidadeA;
        }

        let totalA = this.normalizarNumero(a.total);
        let totalB = this.normalizarNumero(b.total);
        if (totalA != totalB) {
          return totalB - totalA;
        }

        let valorA = this.normalizarNumero(a.valor);
        let valorB = this.normalizarNumero(b.valor);
        return valorB - valorA;
      });

      for (let i = 0; i < itens.length && totalPermitido < limite; i++) {
        let item = itens[i];
        if (!item || !item.resource_id) {
          continue;
        }

        let chave = this.getChavePrecoTopSniper(item.resource_id, this.idPlataforma);
        if (!mapa[chave]) {
          mapa[chave] = true;
          totalPermitido++;
        }
      }

      return mapa;
    }

    private podeBuscarPrecoExternoTopSniper(dataSniper: any, chavesPermitidasFernando: any): boolean {
      if (this.userId != TopSniper.USUARIO_TOP_SNIPER_FERNANDO) {
        return true;
      }

      if (!chavesPermitidasFernando) {
        return true;
      }

      return !!chavesPermitidasFernando[this.getChavePrecoTopSniper(dataSniper.resource_id, this.idPlataforma)];
    }

    private async inicializarDataTable() {
      var urlLinkFutbin = "https://www.futbin.com/players?page=1&eUnt=1&order=desc&sort=ps_price&pos_type=all"
      var dataTopSnipers = $('#cardDadosSnipers').data('dadosSnipers');
      var dataRaridades = $('#cardDadosSnipers').data('raridades');
      dataTopSnipers = $.isArray(dataTopSnipers) ? dataTopSnipers : [];
      dataRaridades = $.isArray(dataRaridades) ? dataRaridades : [];
      // console.log("inicializarDataTable", dataRaridades, dataTopSnipers)
      try {
        // console.log('dataTopSnipers', dataTopSnipers);
        dataTopSnipers = dataTopSnipers.filter((ele: any) => {
          return ele.resource_id != 50570091
            && ele.resource_id != 84124515
            && ele.resource_id != 83892315
            && ele.resource_id != 83940130
            && ele.resource_id != 50557941
            && ele.resource_id != 67265217
            && ele.resource_id != 84136970
            && ele.resource_id != 67336188
            && ele.resource_id != 67347246
            && ele.resource_id != 67336127
            && ele.resource_id != 67335157
            && ele.resource_id != 67335157
            && ele.resource_id != 67110065;
        });
      } catch (error) {
        console.log('FERNANDO ENSINOU CAGADA:: ', error);
      }

      await this.prepararIndicePlayersParaTopSniper(dataTopSnipers);

      var dataTopSnipersAnterior: any = await Util.getDadosTopSniperAnteriorAsync(dataTopSnipers)
      //console.log("dataTopSnipersAnterior", dataTopSnipersAnterior)

      for (let index = 0; index < dataTopSnipers.length; index++) {
        let dataSniper = dataTopSnipers[index];
        try {
          let chaveSnapshotAnterior = Util.getChaveTopSniperSnapshotItem(dataSniper);
          let dataSniperAnterior = dataTopSnipersAnterior && chaveSnapshotAnterior ? dataTopSnipersAnterior[chaveSnapshotAnterior] : null;
          var player = this.getPlayerPorAssetId(dataSniper.asset_id);
          var nomeJogador = this.getNomeJogador(player);
          let newUrlLinkFutbin = `${urlLinkFutbin}&club=${dataSniper.team_id}&nation=${dataSniper.nation_id}`
          let filtroBuscaPreco = this.getPayloadFiltroBuscaPreco(nomeJogador, dataSniper);

          dataTopSnipers[index].nome = nomeJogador;
          dataTopSnipers[index].preco = 0;
          dataTopSnipers[index].preco_total = 0;
          dataTopSnipers[index].preco_identificado = false;
          dataTopSnipers[index].quantidade_mais = dataSniperAnterior && this.normalizarNumero(dataSniper.total) > this.normalizarNumero(dataSniperAnterior.total) ? (this.normalizarNumero(dataSniper.total) - this.normalizarNumero(dataSniperAnterior.total)) : 0;
          dataTopSnipers[index].lucro = 0;
          dataTopSnipers[index].raridade = dataRaridades.find((raridade: any) => raridade.id == dataSniper.rareflag)
          dataTopSnipers[index].urlLinkFutbin = dataSniper.asset_id != dataSniper.resource_id && dataSniper.rareflag >= 3 ? newUrlLinkFutbin + `&version=all_specials` : newUrlLinkFutbin
          dataTopSnipers[index].lucro_unitario = 0;
          dataTopSnipers[index].filtroBuscaPreco = filtroBuscaPreco;

        } catch (error) {
          TopSniperUtil.logTopSniper("ERROR AO PREPARAR CARTA", { erro: error, carta: dataSniper })
          continue
        }

        if (index > 0 && index % 100 == 0) {
          this.registrarProgressoCiclo();
          await this.sleep(0);
        }
      }

      let chavesBuscaPrecoExternoFernando: any = this.getChavesBuscaPrecoExternoFernando(dataTopSnipers);

      this.processandoPrecosExternosFernando = this.userId == TopSniper.USUARIO_TOP_SNIPER_FERNANDO;
      this.chavesPrecosExternosFernandoPendentes = {};
      try {
        for (let index = 0; index < dataTopSnipers.length; index++) {
          let dataSniper = dataTopSnipers[index];
          try {
            let precoTotal = 0;
            let valorTotalGasto = this.normalizarNumero(dataSniper.valor_total_gasto);
            let filtroBuscaPreco = dataSniper.filtroBuscaPreco || this.getPayloadFiltroBuscaPreco(dataSniper.nome, dataSniper);
            let podeBuscarPrecoExterno = this.podeBuscarPrecoExternoTopSniper(dataSniper, chavesBuscaPrecoExternoFernando);
            let dados: IFutbin = await this.getPrecoFutbin(dataSniper.resource_id, this.idPlataforma, filtroBuscaPreco, podeBuscarPrecoExterno);
            let preco = 0;
            preco = this.normalizarPrecoFutbin(dados);
            dataTopSnipers[index].preco = preco;

            if (preco > 0) {
              precoTotal = preco * this.normalizarNumero(dataSniper.total);
              let taxaEA = precoTotal * 0.05;
              dataTopSnipers[index].preco_total = precoTotal;
              dataTopSnipers[index].preco_identificado = true;
              dataTopSnipers[index].lucro = precoTotal - taxaEA - valorTotalGasto;
              dataTopSnipers[index].lucro_unitario = Util.getLucroCarta(dataTopSnipers[index].valor, dataTopSnipers[index].preco)
              this.definicaoTopCartasParaUsuarioLogado(this.userId, dataTopSnipers[index])
            }

          } catch (error) {
            TopSniperUtil.logTopSniper("ERROR AO TRATAR CARTA", { erro: error, carta: dataSniper })
            continue
          }

          if (index > 0 && index % 25 == 0) {
            this.registrarProgressoCiclo();
            await this.sleep(0);
          }
        }
      } finally {
        this.processandoPrecosExternosFernando = false;
      }

      this.preparacaoTopCartasParaUsuarioLogado(this.userId);
      this.limparDadosSnipersDom();
      this.persistirCachePrecoFutbin();
      this.flushPrecosExternosFernando();

      this.initializarTabelaTopSniper(this.compactarDadosTabelaTopSniper(dataTopSnipers))
      App.Util.ocultarLoadingTableContas()
      this.loopBuscasParaAtualizacaoDeFiltros()
    }

    private compactarDadosTabelaTopSniper(dataTopSnipers: any[]): any[] {
      if (!$.isArray(dataTopSnipers)) {
        return [];
      }

      dataTopSnipers.forEach((item: any): void => {
        if (!item) return;
        delete item.filtroBuscaPreco;
        delete item.player_info;
        delete item.historico_frequencia;
      });

      return dataTopSnipers;
    }

    private limparMemoriaTopSniper(): void {
      try {
        // Grava o que ficou pendente antes de descartar o cache em memoria.
        this.persistirCachePrecoFutbin();
        this.cancelarWatchdogRecarregamento();

        if (this.timeoutLoopTopSniper) {
          clearTimeout(this.timeoutLoopTopSniper);
          this.timeoutLoopTopSniper = null;
        }

        if (this.timeoutFlushPrecosExternosFernando) {
          clearTimeout(this.timeoutFlushPrecosExternosFernando);
          this.timeoutFlushPrecosExternosFernando = null;
        }

        this.precosExternosFernandoPendentes = [];
        this.chavesPrecosExternosFernandoPendentes = {};
        this.processandoPrecosExternosFernando = false;
        this.cachePrecoFutbinMemoria = null;
        this.indiceCachePrecoFutbin = null;
        this.objPlayersPorId = {};
        TopSniper.objPlayers = null;

        this.limparDadosSnipersDom();

        if (TopSniper.objDataTableTopSniper && $.fn.dataTable && $.fn.dataTable.isDataTable(this.elDataTableTopSniper[0])) {
          TopSniper.objDataTableTopSniper.clear();
          TopSniper.objDataTableTopSniper.destroy();
          TopSniper.objDataTableTopSniper = null;
        }
      } catch (e) { }
    }

    private limparDadosSnipersDom(): void {
      const $cardDadosSnipers = $('#cardDadosSnipers');
      if ($cardDadosSnipers.length) {
        $cardDadosSnipers.removeData('dadosSnipers');
        $cardDadosSnipers.removeData('raridades');
        // removeData so limpa o cache do jQuery: o JSON bruto continua no atributo HTML,
        // ocupando memoria o ciclo inteiro. Neste ponto a inteligencia ja leu os dados.
        $cardDadosSnipers.removeAttr('data-dados-snipers');
        $cardDadosSnipers.removeAttr('data-raridades');
      }
    }

    private navegarSubstituindoHistorico(url: string): void {
      this.limparMemoriaTopSniper();
      window.location.replace(url);
    }

    private recarregarTopSniperPorFormulario(): void {
      const $form = $('#section-components form').first();
      if (!$form.length || String($form.attr('method') || 'GET').toUpperCase() !== 'GET') {
        $('#section-components > div > div > div > div > div > div > div.card-body > form > div > div.col-md-12.pt-1.pull-right > div > button').click();
        return;
      }

      const action = String($form.attr('action') || `${window.location.origin}${window.location.pathname}`);
      const url = new URL(action, window.location.origin);
      const params = new URLSearchParams(window.location.search);
      const campos = $form.serializeArray();

      campos.forEach((campo: any): void => {
        if (!campo || !campo.name) {
          return;
        }

        params.set(campo.name, campo.value);
      });

      url.search = params.toString();
      this.navegarSubstituindoHistorico(url.toString());
    }

    public initializarTabelaTopSniper(dataTopSnipers: any) {
      let getNumero = (valor: any): number => {
        let numero = Number(valor);
        return isFinite(numero) ? numero : 0;
      };
      let getValorOrdenacaoPreco = (obj: any, valor: any): number => {
        return obj && obj.preco_identificado ? getNumero(valor) : -999999999;
      };
      TopSniper.objDataTableTopSniper = this.elDataTableTopSniper.DataTable({
        language: {
          url: "/datatable-pt-br.json",
        },
        pageLength: this.userId == TopSniper.USUARIO_TOP_SNIPER_FERNANDO ? 100 : 1000,
        deferRender: true,
        bLengthChange: false,
        bInfo: false,
        data: dataTopSnipers,
        bAutoWidth: false,
        rowId: 'id',
        dom: 'Bfrtip',
        select: true,
        buttons: [],
        order: [[3, 'desc'], [4, 'desc']],
        columnDefs: [
          {
            targets: 0,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              if (tipo === 'sort' || tipo === 'type') {
                return obj.nome || '';
              }
              var qualidade = obj.rating < 65 ? '_1' : (obj.rating < 75 ? '_2' : '_3');
              var ehEspecialRaro = obj.rareflag > 3;
              qualidade = ehEspecialRaro ? '_0' : qualidade;
              var bgCard = "e_" + obj.rareflag + qualidade + ".png";
              var urlFutbin = "";
              var divImg = `<div class="playercard-picture"><img src="https://cdn.futnext.com/player/${obj.asset_id}.png" /></div>`
              var nomeraridade = obj.raridade && obj.raridade.nome ? `<span class="text-primary text-center font-weight-bold text-uppercase" style="font-size: 12px;">${obj.rating} - ${obj.raridade.nome}</span>` : ' - '

              data = '<div data-toggle="tooltip" data-placement="top" title="' + obj.nome + '" class="playercard fut21 playercard-s" style="background-image: url(' + "'https://cdn.futnext.com/rarity/" + bgCard + "'" + ');">' +
                '<p class="playercard-rating" style="color: #16181c;padding: 15px;margin-top:-20px;">' + obj.rating + '</p>\n\
                              <div class="playercard-position">' + (obj.hasOwnProperty("preferredPositionNameTraduzido") && obj.preferredPositionNameTraduzido ? obj.preferredPositionNameTraduzido : '') + '</div>\n\
                              <div class="playercard-nation" style="margin-top:-13px;"><img src="https://cdn.futnext.com/nation/'+ obj.nation_id + '.png" alt=""></div>\n\
                              <div class="playercard-club"><img src="https://cdn.futnext.com/club/' + obj.team_id + '.png" alt=""></div>\n\
                              <div class="playercard-name" style="background-color: #000000;color: #ffffff;"><span class="">' + obj.nome + '</span></div>\n\
                              '+ divImg + '\n\
                              <div class="playercard-line playercard-line1"></div><div class="playercard-line playercard-line2">\n\
                              </div><div class="playercard-line playercard-line3"></div>\n\
                              <div class="playercard-line playercard-line4"></div>\n\
                              <div class="playercard-line playercard-line5"></div>'+ nomeraridade + '</div>';
              return data;
            }
          },
          {
            targets: 1,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              if (tipo === 'sort' || tipo === 'type') {
                return getNumero(obj.total);
              }
              return `<span>${obj.total} ${obj.quantidade_mais ? `<span style="font-size: 14px;background-color: #71bf62;font-weight: 700;border-radius: 8px;padding: 2px;color: #ffffff;position: relative;top: -9px;">+${obj.quantidade_mais}</span>` : ''}</span>`;
            }
          },
          {
            targets: 2,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              if (tipo === 'sort' || tipo === 'type') {
                return getNumero(obj.preco);
              }
              return `<span title="${obj.valor_all}"><i class="ni ni-money-coins mr-2" style="color: #e3a800" aria-hidden="true"></i>${obj.valor}</span><br />
              <span title="${obj.valor_all}"><img alt="sistema-futsniperweb" class="mr-1" src="/img/icons/futbin.png" style="width: 20px;" />${obj.preco}</span>`
            }
          },
          {
            targets: 3,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              if (tipo === 'sort' || tipo === 'type') {
                return getValorOrdenacaoPreco(obj, obj.lucro);
              }
              return `<span><i class="fas fa-arrow-up text-success mr-2" aria-hidden="true"></i>${obj.lucro}</span>`;
            }
          },
          {
            targets: 4,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              if (tipo === 'sort' || tipo === 'type') {
                return getValorOrdenacaoPreco(obj, obj.preco_total);
              }
              return `<span><i class="fas fa-arrow-down text-danger mr-2" aria-hidden="true"></i>${obj.valor_total_gasto}</span><br /><span><i class="fas fa-arrow-up text-success mr-2" aria-hidden="true"></i>${obj.preco_total}</span>`;
            }
          },
          {
            targets: 5,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              if (tipo === 'sort' || tipo === 'type') {
                return obj.created_at || '';
              }
              return obj.created_at;
            }
          },
          {
            targets: 6,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              if (tipo === 'sort' || tipo === 'type') {
                return obj.ids_filtros || '';
              }
              return `<a href="${obj.urlLinkFutbin || '#'}" target="_blank"><i class="fa-solid fa-link mr-2"></i></a><i class="fas fa-filter mr-2 ml-1" title="${obj.ids_filtros || ''}"></i>`
            }
          },
        ],
      });
    }

    private loopBuscasParaAtualizacaoDeFiltros() {
      if (this.timeoutLoopTopSniper) {
        return;
      }

      this.cancelarWatchdogRecarregamento();

      if (TopSniper.USUARIOS_PERMITIDOS.includes(this.userId)) {
        this.timeoutLoopTopSniper = setTimeout(() => {
          this.timeoutLoopTopSniper = null;

          try {
            console.log("##### TIMEOUT...", Util.getCounterValue('contadorBuscasTopSniper'), new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString(), ' #####')
            if (Util.getCounterValue('contadorBuscasTopSniper') == 0) {
              console.log("PROCESSO INICIAL...", new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())
            }
            if (Util.getCounterValue('contadorBuscasTopSniper') >= 5) {
              console.log("INICIAR NOVO PROCESSO...", new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())
              Util.resetCounter('contadorBuscasTopSniper')
              this.recarregar(this.userId)
              return
            }
            if (Util.getCounterValue('contadorBuscasTopSniper') > 0) {
              console.log("REPETIR PROCESSO...", new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())
            }
            Util.incrementCounter('contadorBuscasTopSniper')
            this.recarregarTopSniperPorFormulario();
          } catch (erro) {
            // Se a navegacao falhar aqui, ninguem mais recarregaria a tela: rearma o watchdog.
            console.error('TOP SNIPER: falha ao recarregar no fim do ciclo', erro);
            this.iniciarWatchdogRecarregamento(60000);
          }
        }, this.getrecarregamentoTopSniperByUsuarioLogado(this.userId));
      }
    }

    private getrecarregamentoTopSniperByUsuarioLogado(userId: number) {
      switch (this.userId) {
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          return 120000;
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          return 120000;
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          return 120000;
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          return 120000;
        default:
          return 120000;
      }
    }

    private definicaoTopCartasParaUsuarioLogado(userId: number, dataTopSniper: ICartaTopSniper) {
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          this.topSniperPc.condicaoTopCartasImportantes(dataTopSniper);
          break;
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          this.topSniperMarcelo.condicaoTopCartasImportantes(dataTopSniper);
          break;
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          this.topSniperAdminDiego.condicaoTopCartasImportantes(dataTopSniper);
          break;
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          this.topSniperAdminFernando.condicaoTopCartasImportantes(dataTopSniper);
          break;
      }
    }

    private preparacaoTopCartasParaUsuarioLogado(userId: number): void {
      let promessa: any = null;
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          promessa = this.topSniperPc.prepararTopCartas()
          break;
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          promessa = this.topSniperMarcelo.prepararTopCartas()
          break;
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          promessa = this.topSniperAdminDiego.prepararTopCartas()
          break;
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          promessa = this.topSniperAdminFernando.prepararTopCartas()
          break;
      }

      if (promessa && typeof promessa.then === 'function') {
        promessa.then((): void => {
          this.liberarMemoriaPreparacaoTopSniper(userId);
        }, (): void => {
          this.liberarMemoriaPreparacaoTopSniper(userId);
        });
      } else {
        this.liberarMemoriaPreparacaoTopSniper(userId);
      }
    }

    private liberarMemoriaPreparacaoTopSniper(userId: number): void {
      if (userId == TopSniper.USUARIO_TOP_SNIPER_FERNANDO && this.topSniperAdminFernando && (this.topSniperAdminFernando as any).liberarMemoriaAposPreparacao) {
        (this.topSniperAdminFernando as any).liberarMemoriaAposPreparacao();
      }
    }

    private getCachePrecosFutbin(): IStoragePrecoFutbin[] {
      if (this.cachePrecoFutbinMemoria === null) {
        try {
          this.cachePrecoFutbinMemoria = App.Util.getArrayStorage(this.keyStorageCachePrecoFutbin) || [];
          if (this.cachePrecoFutbinMemoria.length > this.limiteCachePrecoFutbin) {
            this.cachePrecoFutbinMemoria = this.limitarCachePrecoFutbin(this.cachePrecoFutbinMemoria);
            App.Util.setArrayStorage(this.keyStorageCachePrecoFutbin, this.cachePrecoFutbinMemoria);
          }
        } catch (e) {
          this.cachePrecoFutbinMemoria = [];
          try {
            localStorage.removeItem(this.keyStorageCachePrecoFutbin);
          } catch (erroLimpeza) { }
        }
      }

      return this.cachePrecoFutbinMemoria || [];
    }

    private getItemCachePrecoFutbin(resourceId: number | string): IStoragePrecoFutbin {
      const cache = this.getCachePrecosFutbin();
      const indice = this.getIndiceCachePrecoFutbin();
      const chave = resourceId !== null && typeof resourceId !== 'undefined' ? resourceId.toString() : null;
      const posicao = chave !== null && indice.hasOwnProperty(chave) ? indice[chave] : -1;

      return posicao >= 0 && cache[posicao] ? cache[posicao] : null;
    }

    private limitarCachePrecoFutbin(cache: IStoragePrecoFutbin[]): IStoragePrecoFutbin[] {
      if (!cache || cache.length <= this.limiteCachePrecoFutbin) {
        return cache || [];
      }

      // Calcula o timestamp uma vez por item. O comparador anterior criava dois Date por
      // comparacao (milhares de objetos a cada preco novo, com o cache cheio).
      const decorado = cache.map((item: IStoragePrecoFutbin): any => ({
        item: item,
        data: item && item.update_at ? new Date(item.update_at).getTime() : 0
      }));

      decorado.sort((a: any, b: any): number => b.data - a.data);

      return decorado.slice(0, this.limiteCachePrecoFutbin).map((registro: any): IStoragePrecoFutbin => registro.item);
    }

    private getIndiceCachePrecoFutbin(): any {
      if (this.indiceCachePrecoFutbin === null) {
        const cache = this.getCachePrecosFutbin();
        this.indiceCachePrecoFutbin = {};
        for (let i = 0; i < cache.length; i++) {
          if (cache[i] && cache[i].resourceId !== null && typeof cache[i].resourceId !== 'undefined') {
            this.indiceCachePrecoFutbin[cache[i].resourceId.toString()] = i;
          }
        }
      }

      return this.indiceCachePrecoFutbin;
    }

    private addCachePrecoFutbin(itemCache: IStoragePrecoFutbin) {
      let objStoragePrecoFutbin: IStoragePrecoFutbin[] = this.getCachePrecosFutbin();
      const indice = this.getIndiceCachePrecoFutbin();
      const chave = itemCache.resourceId !== null && typeof itemCache.resourceId !== 'undefined' ? itemCache.resourceId.toString() : null;
      const posicao = chave !== null && indice.hasOwnProperty(chave) ? indice[chave] : -1;

      if (posicao >= 0) {
        objStoragePrecoFutbin[posicao] = itemCache;
      } else {
        objStoragePrecoFutbin.push(itemCache);
        if (chave !== null) {
          indice[chave] = objStoragePrecoFutbin.length - 1;
        }
      }

      this.cachePrecoFutbinMemoria = objStoragePrecoFutbin;
      // Persistencia adiada: gravar aqui reserializava os 500 itens do cache a cada preco novo.
      this.cachePrecoFutbinAlterado = true;
    }

    /**
     * Aplica o teto e grava o cache de precos uma unica vez no fim do ciclo.
     */
    private persistirCachePrecoFutbin(): void {
      if (!this.cachePrecoFutbinAlterado) {
        return;
      }

      this.cachePrecoFutbinAlterado = false;

      try {
        const cache = this.limitarCachePrecoFutbin(this.getCachePrecosFutbin());
        this.cachePrecoFutbinMemoria = cache;
        this.indiceCachePrecoFutbin = null;
        App.Util.setArrayStorage(this.keyStorageCachePrecoFutbin, cache);
      } catch (e) { }
    }

    private getMinutosCachePrecoFutbinAtual(): number {
      return this.minutosCachePrecoFutbin;
    }

    private deveForcarPrecoFrescoFernando(): boolean {
      if (this.userId != TopSniper.USUARIO_TOP_SNIPER_FERNANDO) {
        return false;
      }

      let forcarAte = Number(sessionStorage.getItem(this.keyStorageForcarPrecoFrescoFernando) || 0);
      return isFinite(forcarAte) && forcarAte > Date.now();
    }

    private getInstanciaTokenFernando(): string {
      let token = sessionStorage.getItem(this.keyStorageInstanciaTokenFernando);
      if (!token) {
        token = `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
        sessionStorage.setItem(this.keyStorageInstanciaTokenFernando, token);
      }

      return token;
    }

    private registrarPrecoExternoFernando(resourceId: number, idPlataforma: number, dados: IFutbin, forcarPrecoFresco: boolean, fonte: string = null): void {
      if (this.userId != TopSniper.USUARIO_TOP_SNIPER_FERNANDO || !this.urlsInteligenciaFernando || !this.urlsInteligenciaFernando.preco) {
        return;
      }

      let preco = this.normalizarPrecoFutbin(dados);
      if (preco <= 0) {
        return;
      }

      let chave = this.getChavePrecoTopSniper(resourceId, idPlataforma);
      if (this.chavesPrecosExternosFernandoPendentes[chave]) {
        return;
      }

      this.chavesPrecosExternosFernandoPendentes[chave] = true;
      this.precosExternosFernandoPendentes.push({
        resource_id: resourceId,
        id_plataforma: idPlataforma,
        preco: preco,
        fonte: fonte || (dados as any).fonte || 'bpftb',
        forcar_preco_fresco: forcarPrecoFresco,
        metadata: this.getMetadataPrecoExternoFernando(resourceId, idPlataforma, preco, fonte, forcarPrecoFresco)
      });

      if (!this.processandoPrecosExternosFernando) {
        this.agendarFlushPrecosExternosFernando();
      }
    }

    private getMetadataPrecoExternoFernando(resourceId: number, idPlataforma: number, preco: number, fonte: string, forcarPrecoFresco: boolean): any {
      return {
        origem: 'top_sniper',
        resource_id: resourceId,
        id_plataforma: idPlataforma,
        preco: preco,
        fonte: fonte || 'bpftb',
        forcar_preco_fresco: forcarPrecoFresco
      };
    }

    private agendarFlushPrecosExternosFernando(): void {
      if (this.timeoutFlushPrecosExternosFernando) {
        return;
      }

      this.timeoutFlushPrecosExternosFernando = setTimeout((): void => {
        this.flushPrecosExternosFernando();
      }, 5000);
    }

    private flushPrecosExternosFernando(): void {
      if (this.timeoutFlushPrecosExternosFernando) {
        clearTimeout(this.timeoutFlushPrecosExternosFernando);
        this.timeoutFlushPrecosExternosFernando = null;
      }

      if (!this.precosExternosFernandoPendentes.length || this.userId != TopSniper.USUARIO_TOP_SNIPER_FERNANDO || !this.urlsInteligenciaFernando || !this.urlsInteligenciaFernando.preco) {
        this.precosExternosFernandoPendentes = [];
        return;
      }

      let mapa: any = {};
      for (let i = 0; i < this.precosExternosFernandoPendentes.length; i++) {
        let item = this.precosExternosFernandoPendentes[i];
        if (!item || !item.resource_id || !item.id_plataforma || !item.preco) {
          continue;
        }

        mapa[this.getChavePrecoTopSniper(item.resource_id, item.id_plataforma)] = item;
      }

      let precos: any[] = [];
      for (let chave in mapa) {
        if (mapa.hasOwnProperty(chave)) {
          precos.push(mapa[chave]);
        }
      }

      this.precosExternosFernandoPendentes = [];
      this.chavesPrecosExternosFernandoPendentes = {};
      if (!precos.length) {
        return;
      }

      let limiteRegistro = this.deveForcarPrecoFrescoFernando() ? this.limiteRegistroPrecoExternoFernandoForcado : this.limiteRegistroPrecoExternoFernando;
      if (precos.length > limiteRegistro) {
        precos = precos.slice(0, limiteRegistro);
      }

      $.ajax({
        url: this.urlsInteligenciaFernando.preco,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          id_user: TopSniper.USUARIO_TOP_SNIPER_FERNANDO,
          instancia_token: this.getInstanciaTokenFernando(),
          fonte: 'bpftb_lote',
          forcar_preco_fresco: this.deveForcarPrecoFrescoFernando(),
          precos: precos
        }),
        beforeSend: function (jqXHR: any): void {
          jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
        }
      });
    }

    private getPrecoFutbin(resource_id: number, id_plataforma: number, filtroBusca: any, permitirBuscaExterna: boolean = true): Promise<IFutbin> {
      return new Promise(async (resolve: any, reject: any) => {

        try {
          let item: IStoragePrecoFutbin = this.getItemCachePrecoFutbin(resource_id);
          let forcarPrecoFresco = this.deveForcarPrecoFrescoFernando();
          let itemTemCacheValido: boolean = !forcarPrecoFresco && item && item.preco && this.normalizarPrecoFutbin(item.preco) > 0 && item.update_at && (App.Util.getMinutosPassadosPartirDaDataInicial(new Date(item.update_at), new Date()) < this.getMinutosCachePrecoFutbinAtual());

          if (itemTemCacheValido) {
            resolve(item.preco);
          } else if (!permitirBuscaExterna || this.extensaoIndisponivel) {
            resolve(null);
          } else {
            await this.sleep(this.userId == TopSniper.USUARIO_TOP_SNIPER_FERNANDO ? App.Util.getRandomInt(20, 80) : App.Util.getRandomInt(50, 1000));

            // Se a extensao nao responder (service worker MV3 derrubado, porta fechada),
            // o callback pode nunca ser chamado e o await abaixo travaria o ciclo inteiro.
            let respondido = false;
            let timeoutResposta: any = null;
            const finalizarBusca = (valor: any): void => {
              if (respondido) {
                return;
              }

              respondido = true;
              if (timeoutResposta) {
                clearTimeout(timeoutResposta);
                timeoutResposta = null;
              }
              resolve(valor);
            };

            timeoutResposta = setTimeout((): void => {
              this.registrarFalhaExtensao();
              finalizarBusca(null);
            }, this.timeoutRespostaExtensao);

            try {
              chrome.runtime.sendMessage(this.idExtensao, {
                evento: "bpftb",
                idJogador: resource_id,
                platform: id_plataforma == 3 ? 'pc' : 'ps',
                nomeJogador: filtroBusca && filtroBusca.name ? filtroBusca.name : null,
                termo: filtroBusca && filtroBusca.termo ? filtroBusca.termo : null,
                filtroBusca: filtroBusca,
                forcarPrecoFresco: forcarPrecoFresco,
                ignorarCachePreco: forcarPrecoFresco
              },
                (resultado: { response: IFutbin, status: boolean, fonte?: string }) => {
                  // Ler lastError evita o "Unchecked runtime.lastError" e detecta porta fechada.
                  const erroExtensao = chrome.runtime.lastError;
                  const extensaoRespondeu = !erroExtensao && !!resultado;

                  // So zera o contador se a resposta chegou DENTRO do prazo: uma resposta atrasada
                  // (que ja caiu no timeout) nao pode mascarar uma extensao lenta demais.
                  if (extensaoRespondeu && !respondido) {
                    this.falhasConsecutivasExtensao = 0;
                  } else if (!extensaoRespondeu) {
                    this.registrarFalhaExtensao();
                  }

                  if (extensaoRespondeu && resultado.status && resultado.response && this.normalizarPrecoFutbin(resultado.response) > 0) {
                    this.addCachePrecoFutbin({ update_at: new Date().toISOString(), resourceId: resource_id, preco: resultado.response });
                    this.registrarPrecoExternoFernando(resource_id, id_plataforma, resultado.response, forcarPrecoFresco, resultado.fonte);
                    finalizarBusca(resultado.response);
                  } else {
                    finalizarBusca(null);
                  }
                });
            } catch (erroEnvio) {
              this.registrarFalhaExtensao();
              finalizarBusca(null);
            }
          }
        } catch (error) {
          console.log('ERROR: ', error);
          resolve(null);
        }
      });
    }

    private async processarRegrasDeUrl(userId: number, urlAtual: string): Promise<string> {
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          return await this.topSniperPc.validarRegrasUrlCarregada(urlAtual)
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          return await this.topSniperMarcelo.validarRegrasUrlCarregada(urlAtual)
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          return await this.topSniperAdminDiego.validarRegrasUrlCarregada(urlAtual)
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          return await this.topSniperAdminFernando.validarRegrasUrlCarregada(urlAtual)
      }
    }

    private recarregar(userId: number) {
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          this.topSniperPc.iniciarRecarregamento()
          break
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          this.topSniperMarcelo.iniciarRecarregamento()
          break
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          this.topSniperAdminDiego.iniciarRecarregamento()
          break
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          this.topSniperAdminFernando.iniciarRecarregamento()
          break
      }
    }
  }
}
